module.exports = __webpack_public_path__ + "static/img/p4_2.f9bb3cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/p4_2.png
// module id = oCR8
// module chunks = 0